import { Text } from '@mantine/core'

import InternalError from '@percent/education-hosted-form/assets/images/internal-error.png'
import NotFoundError from '@percent/education-hosted-form/assets/images/not-found-error.png'
import { ErrorCardProps, ErrorVariant } from './ErrorCard.types'
import { Flex } from '@percent/lemonade'

const images: { [key in ErrorVariant]: string } = {
  [ErrorVariant.INTERNAL]: InternalError,
  [ErrorVariant.NOT_FOUND]: NotFoundError
}

export function ErrorCard({ title, subtitle, variant, children }: ErrorCardProps) {
  return (
    <Flex direction="column" align="center" gap={24} pt={48}>
      <img alt="error" src={images[variant]} />
      <Text fz="24" fw={600}>
        {title}
      </Text>
      {subtitle && <Text variant="subtitle1">{subtitle}</Text>}
      {children}
    </Flex>
  )
}

ErrorCard.variants = ErrorVariant
